import { render } from "./AddQrTemplate.vue?vue&type=template&id=2bd5a478&scoped=true"
import script from "./AddQrTemplate.vue?vue&type=script&lang=js"
export * from "./AddQrTemplate.vue?vue&type=script&lang=js"

import "./AddQrTemplate.vue?vue&type=style&index=0&id=2bd5a478&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd5a478"]])

export default __exports__